import { Directive, OnInit, Renderer2 } from '@angular/core';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';

@Directive({
   selector: '[samwebPasswordTextbox]',
})
export class PasswordTextboxDirective implements OnInit {
   constructor(private renderer: Renderer2, private hostElement: TextBoxComponent) {}

   ngOnInit() {
      this.renderer.setAttribute(this.hostElement.input.nativeElement, 'type', 'password');
   }
}
